export default __webpack_public_path__ + "static/media/eggw.8d94aa43.png";